export default Object.freeze({
  dev  : 'development',
  test : 'test',
  prod : 'production',
});
